import { doGet, doPut } from 'hooks/requests';

export const useHistoryService = () => {
    const revertHistoryAction = async ({ companyId, userActivityId }) => {
        const response = await doPut('/user-activity/revert/', {
            company_id: companyId,
            user_activity_id: userActivityId,
        });
        return response;
    };

    const getHistoryActions = async ({ companyId, page = 1, pageSize = 3 }) => {
        const response = await doGet(
            `/user-activity/?company_id=${companyId}&rows_per_page=${pageSize}&page=${page}`,
        );

        return response;
    };

    return {
        revertHistoryAction,
        getHistoryActions,
    };
};
